export default {
	CMS: {
		PRODUCTS: {
			METADATA: {
				PROD_CODE: 'PROD_CODE'
			},
		},
	},
};
